import { Fragment } from "react";
import { linkify, linkifyTruncated } from "@/lib/utils/linkify";
import { openExternalUrl } from "@/lib/utils/open-url";

/**
 * Vrije tekst van een planner, met de URL's erin aanklikbaar (app#217).
 *
 * Rendert alleen inhoud en geen eigen omhulsel: de aanroeper houdt zijn eigen `<p>` of `<span>` met
 * `whitespace-pre-wrap`, de line-clamp en de rest van de opmaak. Aan de weergave verandert dus
 * niets behalve dat een URL nu een link is.
 */
export function LinkedText({ text, truncated = false }: { text: string; truncated?: boolean }) {
  const segments = truncated ? linkifyTruncated(text) : linkify(text);

  return (
    <>
      {segments.map((segment, index) =>
        segment.type === "link" ? (
          <a
            key={index}
            href={segment.href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(event) => {
              // De webview mag niet weggenavigeerd worden. `openExternalUrl` opent op iOS en
              // Android een in-app browser en op web een nieuw tabblad, precies zoals de
              // WhatsApp-groepslink dat al doet.
              event.preventDefault();
              event.stopPropagation();
              void openExternalUrl(segment.href);
            }}
            className="break-words font-medium text-txt-brand underline"
          >
            {segment.value}
          </a>
        ) : (
          <Fragment key={index}>{segment.value}</Fragment>
        ),
      )}
    </>
  );
}
